/* eslint react/prop-types: 0 */
import React from 'react'
// import CallApp from 'callapp-lib'

import {
  downLoadUrl,
  getAdjustDeeplink,
  appSchemeLink,
  downLoadUrlDic
} from '@scream/utils/url'
import { getLocationVars, converUrlParamsObj, getEnv } from '@/utils/utils'
import { CustomDeeplinkParams } from '@scream/typings/interfaces/bookShare'

import './index.scss'

import defaultIcon from '../../assets/logos/scream-logo.png'

interface IProps {
  appIcon?: string
  screamLinkData: any
  reportData?: any
  customParamsDic: CustomDeeplinkParams
}
/**
 * 打开scream或跳转到App Store的footer
 */

// const isAdjustDeepLink = `${getLocationVars().isAdjustDeepLink}` === '1'

const ToScreamFooter: React.FC<IProps> = ({
  appIcon,
  screamLinkData,
  reportData,
  customParamsDic
}) => {
  // 判断是否有安装scream，否则跳转到appstore
  const handlePushToScreamOrAppStore = (isForTest: boolean | undefined) => {
    // 因为修复不好 2秒后强制跳转到appstore的问题，直接利用adjustdeeplink进行跳转
    // if (isAdjustDeepLink) {
    if (!isForTest && reportData) reportData(2)
    const env = getEnv()
    if (env === 'prod' && isForTest) return
    const customParams = {
      ...customParamsDic
    }
    Object.keys(customParams).forEach((key: string) => {
      customParams[key] = screamLinkData[customParams[key]]
    })
    // console.log(customParams)
    // console.log(
    //   `12222-${getAdjustDeeplink({
    //     ...screamLinkData,
    //     isForTest,
    //     customParams
    //   })}`
    // )
    // return false
    window.location.href = `${getAdjustDeeplink({
      ...screamLinkData,
      isForTest,
      customParams
    })}`
    // const options = {
    //   scheme: { protocol: 'cmsscream', host: 'scream' },
    //   appstore: downLoadUrlDic.appStore,
    //   fallback: downLoadUrl
    // }
    // const callLib = new CallApp(options)

    // callLib.open({
    //   path: converUrlParamsObj(screamLinkData)
    // })
    // return
    // window.location.href = `${appSchemeLink}?${converUrlParamsObj(screamLinkData)}`
    // setTimeout(() => {
    //   window.location.href = downLoadUrl
    //   window.location.href = downLoadUrl
    // }, 2000)
  }

  return (
    <div id='ToScreamFooter-ctr'>
      <div
        className='ToScreamFooter-scream-logo'
        onClick={() => {
          handlePushToScreamOrAppStore(true)
        }}
      >
        <img src={appIcon || defaultIcon} alt='' />
      </div>
      <div className='ToScreamFooter-content'>
        <div>SCREAM</div>
        <div>Download now to read</div>
      </div>
      <div
        className='ToScreamFooter-open-btn'
        onClick={() => handlePushToScreamOrAppStore(false)}
      >
        OPEN
      </div>
    </div>
  )
}

export default ToScreamFooter
